import { useContext } from 'react';
import LanguageContext from '../context/language.context';
import about from '../translations/about';
import styles from '../style/about.module.css';
import { publicAsset } from '../utils/publicAsset';

export function About() {
  const { language } = useContext(LanguageContext);

  return (
    <section id="about" className={ styles.container } aria-labelledby="about-heading">
      <div className={ styles.containerTitle }>
        <h1 id="about-heading" className={ styles.title }>{about[language].title}</h1>
        <p className={ styles.subtitle }>{about[language].whoAmI}</p>
      </div>
      <div className={ styles.main }>
        <div className={ styles.portraitFrame }>
          <img
            src={ publicAsset('/profile.jpg') }
            alt={ about[language].portraitAlt }
            className={ styles.portrait }
            decoding="async"
          />
        </div>
        <div className={ styles.textContainer }>
          <p className={ styles.text }>{about[language].paragraph1}</p>
          <p className={ styles.text }>{about[language].paragraph2}</p>
          <p className={ styles.text }>{about[language].paragraph3}</p>
          <p className={ styles.text }>{about[language].paragraph4}</p>
        </div>
      </div>
    </section>
  );
}
